<header class="app-topbar">
  <div class="page-container topbar-menu">
    <div class="d-flex align-items-center gap-2">
      <app-logo-box />
      <!-- Sidebar Menu Toggle Button -->
      <button class="sidenav-toggle-button px-2" (click)="toggleMobileMenu()">
        <i class="ti ti-menu-deep fs-24"></i>
      </button>

      <!-- Horizontal Menu Toggle Button -->
      <button
        class="topnav-toggle-button px-2"
        (click)="toggleMobileMenu()"
        data-bs-toggle="collapse"
        data-bs-target="#topnav-menu-content"
      >
        <i class="ti ti-menu-deep fs-22"></i>
      </button>

      <div class="incoming-call-container" style="z-index: 1000">
        <app-incoming-call-notification
          (queueListUpdated)="onQueueListFetched($event)"
        />
      </div>

      <!-- <div
        class="topbar-search text-muted d-none d-xl-flex gap-2 align-items-center"
        data-bs-toggle="modal"
        data-bs-target="#searchModal"
        type="button"
        (click)="open(content)"
      >
        <i class="ti ti-search fs-18"></i>
        <span class="me-2">Search something..</span>
        <span class="ms-auto fw-medium">⌘K</span>
      </div> -->
      <!-- <div class="topbar-search text-muted d-none d-xl-flex gap-2 align-items-center " style="background-color: #E0F4F3;" >
          <app-search classParent1="topbar-search text-muted d-none d-xl-flex gap-2 align-items-center"
              (saerchHandler)="open($event)" [show]=true />
      </div> -->

      <!-- <div class="topbar-item d-none d-md-flex">
        <div ngbDropdown>
          <a
            ngbDropdownToggle
            class="topbar-link btn btn-link px-2 drop-arrow-none fw-medium"
            data-bs-toggle="dropdown"
            data-bs-trigger="hover"
            data-bs-offset="0,17"
            aria-haspopup="false"
            aria-expanded="false"
          >
            Pages <i class="ti ti-chevron-down ms-1"></i>
          </a>

          <div ngbDropdownMenu class="dropdown-menu-xxl p-0">
            <div class="row g-0">
              <div class="col-md-4">
                <div class="p-3">
                  <h5 class="mb-2 fw-semibold">UI Components</h5>
                  <ul class="list-unstyled megamenu-list">
                    <li>
                      <a routerLink="/extended-ui/dragula">Dragula</a>
                    </li>
                    <li>
                      <a routerLink="/ui/dropdowns">Dropdowns</a>
                    </li>
                    <li>
                      <a routerLink="/extended-ui/ratings">Ratings</a>
                    </li>
                    <li>
                      <a routerLink="/extended-ui/sweet-alert">Sweet Alerts</a>
                    </li>
                    <li>
                      <a routerLink="/extended-ui/scrollbar">Scrollbar</a>
                    </li>
                    <li>
                      <a routerLink="/form/slider">Range Slider</a>
                    </li>
                  </ul>
                </div>
              </div>

              <div class="col-md-4">
                <div class="p-3">
                  <h5 class="mb-2 fw-semibold">Applications</h5>
                  <ul class="list-unstyled megamenu-list">
                    <li>
                      <a routerLink="/ecommerce/products">eCommerce Pages</a>
                    </li>
                    <li>
                      <a routerLink="/hospital/doctors">Hospital</a>
                    </li>
                    <li>
                      <a routerLink="/apps/email">Email</a>
                    </li>
                    <li>
                      <a routerLink="/apps/calendar">Calendar</a>
                    </li>
                    <li>
                      <a routerLink="">Kanban Board</a>
                    </li>
                    <li>
                      <a routerLink="/invoice/invoices">Invoice Management</a>
                    </li>
                    <li>
                      <a routerLink="/pages/pricing-one">Pricing</a>
                    </li>
                  </ul>
                </div>
              </div>

              <div class="col-md-4 bg-light bg-opacity-50">
                <div class="p-3">
                  <h5 class="mb-2 fw-semibold">Extra Pages</h5>
                  <ul class="list-unstyled megamenu-list">
                    <li>
                      <a routerLink="javascript:void(0);"
                        >Left Sidebar with User</a
                      >
                    </li>
                    <li>
                      <a routerLink="javascript:void(0);">Menu Collapsed</a>
                    </li>
                    <li>
                      <a routerLink="javascript:void(0);">Small Left Sidebar</a>
                    </li>
                    <li>
                      <a routerLink="javascript:void(0);">New Header Style</a>
                    </li>
                    <li>
                      <a routerLink="javascript:void(0);">My Account</a>
                    </li>
                    <li>
                      <a routerLink="pages-coming/soon"
                        >Maintenance & Coming Soon</a
                      >
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> -->
    </div>

    
    <div class="d-flex align-items-center gap-2">
      <!-- <div class="topbar-item d-flex d-xl-none">
        <button
          (click)="open(content)"
          class="topbar-link"
          data-bs-toggle="modal"
          data-bs-target="#searchModal"
          type="button"
        >
          <i class="ti ti-search fs-22"></i>
        </button>
      </div> -->
      <div class="topbar-item d-flex d-xl-none">
        <!-- <app-search 
              classParent2="topbar-item d-flex d-xl-none"
              (saerchHandler)="open($event)"
              [show]=true
          /> -->
      </div>

      <div
        *ngIf="showTwilioStatus"
        class="twilio-status"
        [ngStyle]="{
          'background-color': twilioStatusBg,
          color: twilioStatusText,
          'border-color': twilioStatusBg,
        }"
      >
        <span [ngStyle]="{ color: twilioStatusText }">Status</span>
        <i
          [class]="twilioStatusIcon"
          [ngStyle]="{ color: twilioStatusText }"
        ></i>
      </div>

      <div
        class="queue-wrapper"
        (click)="toggleQueueDropdown()"
        *ngIf="showTwilioStatus"
      >
        <!-- <div class="queue">
          <span class="title">Calls in Queue</span>
          <span class="count">{{ callsInQueue }}</span>
        </div> -->
      <div class="queue" [ngClass]="{'blink-alert': patientInP1Counts > 0}"   (click)="goToCommunicationLogs()">
        <span class="title">P1 Patients in Queue</span>
        <span class="count">{{ patientInP1Counts }}</span>
      </div>
        

        <div class="queue-dropdown" *ngIf="showQueueDropdown && callsInQueue > 0">
          <div class="header mid">Transfer the Active Call</div>

          <div class="item">
            <label>Contacts In Queue</label>
            <span>{{ queueList.length }}</span>
          </div>

          <div class="item">
            <label>Longest Wait</label>
            <span>{{ getLongestWaitTime() }}</span>
          </div>

          <div class="item">
            <label>{{ getOldestQueueNumber() }}</label>
            <span>{{ getOldestQueueName() || "Not Exist" }}</span>
          </div>

          <button class="pick-call-btn" (click)="pickUpNextCall($event)">Pick Next Call</button>
        </div>
      </div>

      <div class="topbar-item" *ngIf="userRole === 'care'">
        <div class="ask-ai-btn" (click)="openAiChat()">
          <svg
            width="19"
            height="18"
            viewBox="0 0 19 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M15.6696 13.9296C15.9114 14.1202 15.9523 14.4708 15.7618 14.7118C14.0514 16.878 11.3317 18.189 8.36872 17.9777C3.61416 17.6384 0.0351034 13.5095 0.374301 8.75498C0.614412 5.38727 2.75626 2.61022 5.67251 1.39752C5.95699 1.2792 6.28238 1.41318 6.40069 1.69768C6.51901 1.98129 6.38416 2.30754 6.10053 2.42498C3.55844 3.48289 1.69408 5.90226 1.48517 8.83411C1.18938 12.9753 4.30655 16.5717 8.44774 16.8666C11.0273 17.0511 13.3963 15.9114 14.8874 14.0219C15.0779 13.78 15.4286 13.7391 15.6696 13.9296Z"
              fill="white"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M11.3023 8.33568C11.0352 8.23302 10.7568 8.15299 10.4688 8.09818C10.4497 8.0947 10.4297 8.09035 10.4097 8.08687C10.2305 8.05555 10.2305 7.79803 10.4097 7.76671C10.4297 7.76323 10.4497 7.75888 10.4688 7.7554C10.7568 7.70059 11.0352 7.62055 11.3023 7.5179C11.458 7.45874 11.6094 7.39175 11.7564 7.31693C12.6856 6.84713 13.4425 6.09025 13.9123 5.1611C13.9871 5.01407 14.0541 4.8627 14.1132 4.70695C14.2159 4.43987 14.2959 4.16148 14.3507 3.8735C14.3542 3.85436 14.3586 3.83435 14.362 3.81435C14.3934 3.63513 14.6509 3.63513 14.6822 3.81435C14.6857 3.83435 14.69 3.85437 14.6935 3.8735C14.7483 4.16148 14.8284 4.43987 14.931 4.70695C14.9902 4.86268 15.0572 5.01406 15.132 5.1611C15.6018 6.09025 16.3587 6.84713 17.2878 7.31693C17.4348 7.39175 17.5862 7.45874 17.742 7.5179C18.009 7.62056 18.2874 7.70059 18.5754 7.7554C18.5946 7.75888 18.6146 7.76323 18.6346 7.76671C18.8138 7.79803 18.8138 8.05555 18.6346 8.08687C18.6146 8.09035 18.5945 8.0947 18.5754 8.09818C18.2874 8.15299 18.009 8.23303 17.742 8.33568C17.5862 8.39484 17.4349 8.46183 17.2878 8.53665C16.3587 9.00645 15.6018 9.76333 15.132 10.6925C15.0572 10.8395 14.9902 10.9909 14.931 11.1466C14.8284 11.4137 14.7483 11.6921 14.6935 11.9801C14.69 11.9992 14.6857 12.0192 14.6822 12.0392C14.6509 12.2185 14.3934 12.2185 14.362 12.0392C14.3586 12.0192 14.3542 11.9992 14.3507 11.9801C14.2959 11.6921 14.2159 11.4137 14.1132 11.1466C14.0541 10.9909 13.9871 10.8395 13.9123 10.6925C13.4425 9.76333 12.6856 9.00645 11.7564 8.53665C11.6094 8.46183 11.458 8.39484 11.3023 8.33568Z"
              fill="white"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M9.56064 2.80615C9.28659 2.63824 8.97948 2.51644 8.65151 2.45381C8.6402 2.45207 8.62976 2.45033 8.61845 2.44772C8.51927 2.43032 8.51927 2.28764 8.61845 2.27024C8.62976 2.26763 8.6402 2.26589 8.65151 2.26415C8.97951 2.20151 9.28661 2.07972 9.56064 1.91181C9.66504 1.84744 9.76509 1.77697 9.85993 1.69954C10 1.5847 10.1287 1.45593 10.2436 1.31586C10.321 1.22103 10.3915 1.12098 10.4559 1.01657C10.6238 0.742521 10.7456 0.435417 10.8082 0.107444C10.81 0.0961339 10.8117 0.085694 10.8143 0.0743836C10.8317 -0.0247945 10.9744 -0.0247945 10.9918 0.0743836C10.9944 0.0856933 10.9961 0.0961333 10.9979 0.107444C11.0605 0.435439 11.1823 0.742543 11.3502 1.01657C11.4146 1.12097 11.4851 1.22102 11.5625 1.31586C11.6773 1.45593 11.8061 1.58468 11.9462 1.69954C12.041 1.77697 12.141 1.84743 12.2455 1.91181C12.5195 2.07972 12.8266 2.20152 13.1546 2.26415C13.1659 2.26589 13.1763 2.26763 13.1876 2.27024C13.2868 2.28764 13.2868 2.43032 13.1876 2.44772C13.1763 2.45033 13.1659 2.45207 13.1546 2.45381C12.8266 2.51645 12.5195 2.63825 12.2455 2.80615C12.1411 2.87053 12.041 2.941 11.9462 3.01843C11.8061 3.13326 11.6773 3.26203 11.5625 3.4021C11.4851 3.49693 11.4146 3.59698 11.3502 3.70139C11.1823 3.97544 11.0605 4.28255 10.9979 4.61052C10.9961 4.62183 10.9944 4.63227 10.9918 4.64358C10.9744 4.74276 10.8317 4.74276 10.8143 4.64358C10.8117 4.63227 10.81 4.62183 10.8082 4.61052C10.7456 4.28252 10.6238 3.97542 10.4559 3.70139C10.3915 3.59699 10.321 3.49694 10.2436 3.4021C10.1288 3.26203 9.99999 3.13328 9.85993 3.01843C9.7651 2.941 9.66505 2.87053 9.56064 2.80615Z"
              fill="white"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M17.2705 3.92852C17.3949 4.11035 17.4845 4.31914 17.5271 4.54534C17.5288 4.55143 17.5297 4.55839 17.5315 4.56535C17.5419 4.6245 17.6272 4.6245 17.6376 4.56535C17.6393 4.55839 17.6402 4.55143 17.6419 4.54534C17.6846 4.31914 17.7742 4.11035 17.8986 3.92852C17.9412 3.86762 17.9873 3.80846 18.0378 3.75365C18.0717 3.71711 18.1074 3.68144 18.1439 3.64752C18.1987 3.59706 18.2579 3.55095 18.3188 3.50832C18.5006 3.38391 18.7094 3.2943 18.9356 3.25168C18.9417 3.24994 18.9486 3.24907 18.9556 3.24733C19.0148 3.23689 19.0148 3.15163 18.9556 3.14119C18.9486 3.13945 18.9417 3.13858 18.9356 3.13684C18.7094 3.09421 18.5006 3.0046 18.3188 2.88021C18.2579 2.83758 18.1987 2.79147 18.1439 2.74101C18.1074 2.70708 18.0717 2.67141 18.0378 2.63487C17.9873 2.58006 17.9412 2.5209 17.8986 2.46C17.7742 2.27817 17.6846 2.06938 17.6419 1.84319C17.6402 1.8371 17.6393 1.83014 17.6376 1.82318C17.6271 1.76402 17.5419 1.76402 17.5315 1.82318C17.5297 1.83014 17.5288 1.8371 17.5271 1.84319C17.4845 2.06938 17.3949 2.27818 17.2705 2.46C17.2278 2.5209 17.1817 2.58006 17.1313 2.63487C17.0973 2.67141 17.0617 2.70708 17.0251 2.74101C16.9703 2.79147 16.9112 2.83758 16.8503 2.88021C16.6684 3.00461 16.4596 3.09422 16.2334 3.13684C16.2274 3.13858 16.2204 3.13945 16.2134 3.14119C16.1543 3.15163 16.1543 3.23689 16.2134 3.24733C16.2204 3.24907 16.2274 3.24994 16.2334 3.25168C16.4596 3.29431 16.6684 3.38392 16.8503 3.50832C16.9112 3.55095 16.9703 3.59706 17.0251 3.64752C17.0617 3.68144 17.0973 3.71711 17.1313 3.75365C17.1817 3.80846 17.2278 3.86762 17.2705 3.92852Z"
              fill="white"
            />
          </svg>
          <span>Ask AI</span>
        </div>
      </div>

      <div class="topbar-item">
        <div ngbDropdown>
          <button
            ngbDropdownToggle
            class="topbar-link arrow-none"
            data-bs-toggle="dropdown"
            data-bs-offset="0,25"
            type="button"
            aria-haspopup="false"
            aria-expanded="false"
          >
            <img
              src="assets/images/flags/us.svg"
              alt="user-image"
              class="w-100 rounded"
              height="18"
              id="selected-language-image"
            />
          </button>

          <!-- <div ngbDropdownMenu class="dropdown-menu-end">
            @for (item of languageList; track $index) {
              <a
                ngbDropdownItem
                href="javascript:void(0);"
                data-translator-lang="en"
              >
                <img
                  [src]="item.flag"
                  alt="user-image"
                  class="me-1 rounded"
                  height="18"
                  data-translator-image
                />
                <span class="align-middle">{{ item.name }}</span>
              </a>
            }
          </div> -->
        </div>
      </div>

      <div class="topbar-item">
        <div ngbDropdown>
          <button
            ngbDropdownToggle
            class="topbar-link drop-arrow-none"
            data-bs-toggle="dropdown"
            data-bs-offset="0,25"
            type="button"
            data-bs-auto-close="outside"
            aria-haspopup="false"
            aria-expanded="false"
          >
            <i class="ti ti-bell animate-ring fs-22"></i>
            <span class="noti-icon-badge"></span>
          </button>

          <!-- <div
            ngbDropdownMenu
            class="p-0 dropdown-menu-end dropdown-menu-lg"
            style="min-height: 300px"
          >
            <div class="p-3 border-bottom border-dashed">
              <div class="row align-items-center">
                <div class="col">
                  <h6 class="m-0 fs-16 fw-semibold">Notifications</h6>
                </div>
                <div class="col-auto">
                  <div ngbDropdown class="dropdown">
                    <a
                      ngbDropdownToggle
                      class="drop-arrow-none link-dark"
                      data-bs-toggle="dropdown"
                      data-bs-offset="0,15"
                      aria-expanded="false"
                    >
                      <i class="ti ti-settings fs-22 align-middle"></i>
                    </a>
                    <div ngbDropdownMenu class="dropdown-menu-end">
                      <a href="javascript:void(0);" ngbDropdownItem
                        >Mark as Read</a
                      >

                      <a href="javascript:void(0);" ngbDropdownItem
                        >Delete All</a
                      >

                      <a href="javascript:void(0);" ngbDropdownItem
                        >Do not Disturb</a
                      >

                      <a href="javascript:void(0);" ngbDropdownItem
                        >Other Settings</a
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <ngx-simplebar
              class="position-relative z-2 card shadow-none rounded-0"
              style="max-height: 300px"
              data-simplebar
            > -->
             <!-- <div
                class="dropdown-item notification-item py-2 text-wrap active"
                id="notification-1"
              >
                <span class="d-flex align-items-center">
                   <span class="me-3 position-relative flex-shrink-0">
                    <img
                      src="assets/images/users/avatar-2.jpg"
                      class="avatar-md rounded-circle"
                      alt=""
                    />
                    <span
                      class="position-absolute rounded-pill bg-danger notification-badge"
                    >
                      <i class="ti ti-message-circle"></i>
                      <span class="visually-hidden">unread messages</span>
                    </span>
                  </span>
                  <span class="flex-grow-1 text-muted">
                    <span class="fw-medium text-body">Glady Haid</span>
                    commented on
                    <span class="fw-medium text-body">paces admin status</span>
                    <br />
                    <span class="fs-12">25m ago</span>
                  </span>
                  <span class="notification-item-close">
                    <button
                      type="button"
                      class="btn btn-ghost-danger rounded-circle btn-sm btn-icon"
                      data-dismissible="#notification-1"
                    >
                      <i class="ti ti-x fs-16"></i>
                    </button>
                  </span>
                </span>
              </div>

              <div
                class="dropdown-item notification-item py-2 text-wrap"
                id="notification-2"
              >
                <span class="d-flex align-items-center">
                  <span class="me-3 position-relative flex-shrink-0">
                    <img
                      src="assets/images/users/avatar-4.jpg"
                      class="avatar-md rounded-circle"
                      alt=""
                    />
                    <span
                      class="position-absolute rounded-pill bg-info notification-badge"
                    >
                      <i class="ti ti-currency-dollar"></i>
                      <span class="visually-hidden">unread messages</span>
                    </span>
                  </span>
                  <span class="flex-grow-1 text-muted">
                    <span class="fw-medium text-body">Tommy Berry</span> donated
                    <span class="text-success">{{ currency }}100.00</span> for
                    <span class="fw-medium text-body"
                      >Carbon removal program</span
                    >
                    <br />
                    <span class="fs-12">58m ago</span>
                  </span>
                  <span class="notification-item-close">
                    <button
                      type="button"
                      class="btn btn-ghost-danger rounded-circle btn-sm btn-icon"
                      data-dismissible="#notification-2"
                    >
                      <i class="ti ti-x fs-16"></i>
                    </button>
                  </span>
                </span>
              </div>

              <div
                class="dropdown-item notification-item py-2 text-wrap"
                id="notification-3"
              >
                <span class="d-flex align-items-center">
                  <div class="avatar-md flex-shrink-0 me-3">
                    <span
                      class="avatar-title bg-success-subtle text-success rounded-circle fs-22"
                    >
                      <iconify-icon
                        icon="solar:wallet-money-bold-duotone"
                      ></iconify-icon>
                    </span>
                  </div>
                  <span class="flex-grow-1 text-muted">
                    You withdraw a
                    <span class="fw-medium text-body">{{ currency }}500</span>
                    by <span class="fw-medium text-body">New York ATM</span>
                    <br />
                    <span class="fs-12">2h ago</span>
                  </span>
                  <span class="notification-item-close">
                    <button
                      type="button"
                      class="btn btn-ghost-danger rounded-circle btn-sm btn-icon"
                      data-dismissible="#notification-3"
                    >
                      <i class="ti ti-x fs-16"></i>
                    </button>
                  </span>
                </span>
              </div> 

              <div
                class="dropdown-item notification-item py-2 text-wrap"
                id="notification-4"
              >
                <span class="d-flex align-items-center">
                  <span class="me-3 position-relative flex-shrink-0">
                    <img
                      src="assets/images/users/avatar-7.jpg"
                      class="avatar-md rounded-circle"
                      alt=""
                    />
                    <span
                      class="position-absolute rounded-pill bg-secondary notification-badge"
                    >
                      <i class="ti ti-plus"></i>
                      <span class="visually-hidden">unread messages</span>
                    </span>
                  </span>
                  <span class="flex-grow-1 text-muted">
                    <span class="fw-medium text-body">Richard Allen</span>
                    followed you in
                    <span class="fw-medium text-body">Facebook</span>
                    <br />
                    <span class="fs-12">3h ago</span>
                  </span>
                  <span class="notification-item-close">
                    <button
                      type="button"
                      class="btn btn-ghost-danger rounded-circle btn-sm btn-icon"
                      data-dismissible="#notification-4"
                    >
                      <i class="ti ti-x fs-16"></i>
                    </button>
                  </span>
                </span>
              </div>

              <div
                class="dropdown-item notification-item py-2 text-wrap"
                id="notification-5"
              >
                <span class="d-flex align-items-center">
                  <span class="me-3 position-relative flex-shrink-0">
                    <img
                      src="assets/images/users/avatar-10.jpg"
                      class="avatar-md rounded-circle"
                      alt=""
                    />
                    <span
                      class="position-absolute rounded-pill bg-danger notification-badge"
                    >
                      <i class="ti ti-heart-filled"></i>
                      <span class="visually-hidden">unread messages</span>
                    </span>
                  </span>
                  <span class="flex-grow-1 text-muted">
                    <span class="fw-medium text-body">Victor Collier</span>
                    liked you recent photo in
                    <span class="fw-medium text-body">Instagram</span>
                    <br />
                    <span class="fs-12">10h ago</span>
                  </span>
                  <span class="notification-item-close">
                    <button
                      type="button"
                      class="btn btn-ghost-danger rounded-circle btn-sm btn-icon"
                      data-dismissible="#notification-5"
                    >
                      <i class="ti ti-x fs-16"></i>
                    </button>
                  </span>
                </span>
              </div> -->
            <!-- </ngx-simplebar> -->

            <!-- <div
              style="height: 300px"
              class="d-flex align-items-center justify-content-center text-center position-absolute top-0 bottom-0 start-0 end-0 z-1"
            >
              <div>
                <iconify-icon
                  icon="line-md:bell-twotone-alert-loop"
                  class="fs-80 text-secondary mt-2"
                ></iconify-icon>
                <h4 class="fw-semibold mb-0 fst-italic lh-base mt-3">
                  Hey! 👋 <br />You have no any notifications
                </h4>
              </div>
            </div>

            <a
              href="javascript:void(0);"
              class="dropdown-item notification-item position-fixed z-2 bottom-0 text-center text-reset text-decoration-underline link-offset-2 fw-bold notify-item border-top border-light py-2"
            >
              View All
            </a>
          </div>
        </div> -->
      </div>
      </div>

      <!-- <div class="topbar-item d-none d-sm-flex">
        <div ngbDropdown>
          <button
            ngbDropdownToggle
            class="topbar-link drop-arrow-none"
            data-bs-toggle="dropdown"
            data-bs-offset="0,25"
            type="button"
            aria-haspopup="false"
            aria-expanded="false"
          >
            <i class="ti ti-apps fs-22"></i>
          </button>
          <div ngbDropdownMenu class="dropdown-menu-end dropdown-menu-lg p-0">
            <div class="p-2">
              @for (chunk of appsChunks; track $index) {
                <div class="row g-0">
                  @for (item of chunk; track $index) {
                    <div class="col-4">
                      <a class="dropdown-icon-item" routerLink="#">
                        <img [src]="item.image" alt="slack" />
                        <span>{{ item.name }}</span>
                      </a>
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        </div>
      </div> -->

      <!-- <div class="topbar-item d-none d-sm-flex">
        <button class="topbar-link" (click)="settingMenu()" type="button">
          <i class="ti ti-settings fs-22"></i>
        </button>
      </div> -->

      <!-- <div class="topbar-item d-none d-sm-flex">
        <button
          class="topbar-link"
          (click)="changeTheme()"
          id="light-dark-mode"
          type="button"
        >
          @if (color === 'light') {
            <i class="ti ti-moon fs-22"></i>
          } @else {
            <i class="ti ti-sun fs-22"></i>
          }
        </button>
      </div> -->

      <div class="topbar-item nav-user">
        <a
          class="topbar-link drop-arrow-none"
          (click)="settingMenu()"
          type="button"
          aria-haspopup="false"
          aria-expanded="false"
        >
          <ng-container
            *ngIf="this.userSettings.userInfo.imagePath; else avatarTemplate"
          >
            <img
              [src]="this.userSettings.userInfo.imagePath"
              alt="user-image"
              class="rounded-circle me-lg-2 d-flex user-avatar-img"
            />
          </ng-container>
          <ng-template #avatarTemplate>
            <div class="rounded-circle me-lg-2 d-flex user-avatar-initials">
              {{
                getInitials(
                  this.userSettings.userInfo.first_name,
                  this.userSettings.userInfo.last_name
                )
              }}
            </div>
          </ng-template>

          <span class="d-lg-flex flex-column gap-1 d-none">
            <h5 class="my-0">
              {{ this.userSettings.userInfo.first_name }}
              {{ this.userSettings.userInfo.last_name }}
            </h5>
            <!-- <h6 class="my-0 fw-normal">
              {{ this.userSettings.userInfo.email }}
            </h6> -->
          </span>
          <i class="ti ti-chevron-down d-none d-lg-block align-middle ms-2"></i>
        </a>
      </div>
    </div>
  </div>
</header>

<app-ai-chat [aichat]="aichat" (toggleChatBox)="closeAiChat()" />
